import React, { useEffect, useState } from 'react';
import userIcon from 'assets/images/icon-user.svg';
import chatbotIcon from 'assets/images/icon-chatbot.svg';
import sourceIcon from 'assets/images/icon-source.svg';
import remarkGfm from 'remark-gfm';
import Markdown from 'react-markdown';
import rehypeExternalLinks from 'rehype-external-links';
import { quickDownloadOssFile } from 'utils';
import { imageSceneMapping, contentReviewStatusStyles, contentReviewStatusOptions } from 'constants';
import ImageView from 'components/image-view/ImageView';
import './index.css';

// props type:
// {
// 	chat: {
// 		question: object,
// 		answer: object
// 	},
// 	onSelected: func,
// 	isSelected: bool
//}
const ChatMessagePair = (props) => {
	const FINAL_ANSWER_SYMBOL = '_FINAL_ANSWER_';
	const SOURCE_SYMBOL = '_SOURCE_';
	const INTENTION_SYMBOL = '_INTENTION_';
	const [reviewStatus, setReviewStatus] = useState(null);

	useEffect(() => {
		const messageStatus = props.chat.answer.status;
		if (!messageStatus || messageStatus === 'Pending') {
			setReviewStatus(null);
		} else {
			setReviewStatus(messageStatus);
		}
	}, [props.chat.answer.review]);

	// MARK: - help functions
	const displayMessage = (message) => {
		var msg = message.replace(FINAL_ANSWER_SYMBOL, '');
		msg = msg.split(INTENTION_SYMBOL)[0];
		msg = msg.split(SOURCE_SYMBOL)[0];
		return msg;
	};

	function getSourceFileName(filePath) {
		return filePath.split('/').pop();
	}

	function isImageDetectionQuestion() {
		return /[0-9]\|[^.]+\.(png|jpeg|jpg|JPG|PNG|JPEG)/.test(props.chat.question.content);
	}

	function getImageDetectionScene() {
		const rawMessage = props.chat.question.content;
		const sceneVal = rawMessage.split('|')[0];
		return imageSceneMapping[sceneVal] ?? '未知场景';
	}

	function getImageFileName() {
		const rawMessage = props.chat.question.content;
		const messageFrags = rawMessage.split('|');
		return messageFrags.length > 1 ? messageFrags[1] : '';
	}

	// MARK: - action handler
	async function downloadFileLinkClicked(filePath) {
		await quickDownloadOssFile(filePath);
	}

	return (
		<div
			className={`chat-message-container ${props.isSelected && 'review-selected'}`}
			onClick={() => props.onSelected()}
		>
			{reviewStatus && (
				<div
					className="chat-message-status-icon"
					style={{
						...contentReviewStatusStyles[reviewStatus],
					}}
				>
					{contentReviewStatusOptions.filter((opt) => opt.value === reviewStatus)[0]['label']}
				</div>
			)}
			<div className="chat-message question">
				{isImageDetectionQuestion() ? (
					<div className="content-group">
						<div className="content">封箱胶图片问题处理</div>
						<div className="image-wrapper">
							<ImageView
								ossKey={getImageFileName()}
								appId="default"
								filename={getImageFileName()}
								styles={{
									loadingStyles: {
										width: '200px',
										height: '200px',
									},
									imageStyles: {
										maxWidth: '200px',
										maxHeight: '270px',
										width: undefined,
										height: undefined,
									},
								}}
							/>
						</div>
						<div className="content">{`该封箱胶的使用场景是${getImageDetectionScene()}`}</div>
					</div>
				) : (
					<div className="content">{props.chat.question.content}</div>
				)}
				<div className="message-icon-container">
					<img src={userIcon} width={24} height={24} />
				</div>
			</div>
			<div className="chat-message answer">
				<div className="message-icon-container">
					<img src={chatbotIcon} width={24} height={24} />
				</div>
				<div className="content markdown-container">
					<Markdown
						remarkPlugins={[remarkGfm]}
						rehypePlugins={[[rehypeExternalLinks, { target: '_blank', rel: ['noopener', 'noreferrer'] }]]}
					>
						{displayMessage(props.chat.answer.content)}
					</Markdown>
				</div>
			</div>
			{props.chat.answer.source.length > 0 && (
				<div className="chat-message source">
					<div className="message-icon-container file-source-header">
						<img className="file-source-icon" src={sourceIcon} width={24} height={24} />
						File Source
					</div>
					{props.chat.answer.source.map((file) => (
						<div className="file-link" onClick={() => downloadFileLinkClicked(file)}>
							{getSourceFileName(file)}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default ChatMessagePair;
